import { atom } from 'nanostores'

export type DialogQueueItem = {
  id: string
  payload?: any
}

export type DialogQueue = DialogQueueItem[]

export const $dialogQueue = atom<DialogQueue>([])
